<template>
   <div class="update-cohort container-fluid"> 
     <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>  
        <!-- Update Lesson Overlay -->
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Perc cursor-pointer" v-on:click="updateShowEditCohortOverlayFlag($event,false)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
                  </div>  
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-3 col-lg-3">
                </div>  
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-right-0Px">
                  Cohort Name
                </div>
                <div class="col-md-4 col-lg-4">
                  <div class="form-group">
                        <div class="col-sm-12 padding-left-0Perc">
                            <input type="text" class="form-control" v-model="cohortNameValue">
                        </div>
                    </div>
                </div>
                <div class="col-md-3 col-lg-3">
                </div>  
              </div>

              <div v-if="showRecommendedActionUI">
                <hr width="94%" size="10px"/>
                <div class="row vertical-align margin-bottom-2Perc">
                  <div class="row col-md-1 col-lg-1"></div>
                  <div class="row col-md-3 col-lg-3 create-lesson-input-text-style text-align-left">
                    <b>Recommended Action Setup:</b>
                  </div>
                  <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">  
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-3 col-lg-3"></div>
                </div>

                <div class="row margin-bottom-2Perc vertical-align" v-if="(cohortObjectToPass.RecommendActionsData.length > 0)">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-xs-10 col-sm-10 col-md-10 col-lg-10">
                    <div class="table-responsive margin-Top-3Perc" >
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th class="text-align-center font-size-15px border-right">SR. No.</th>
                            <th class="text-align-center font-size-15px border-right">Number of scheduled user meeting(s)</th>
                            <th class="text-align-center font-size-15px padding-left-0px padding-right-0px">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(currObj, index) in cohortObjectToPass.RecommendActionsData" :key="'recommended_action_' + index">
                            <td class="border-right text-align-center col-lg-3">{{(index + 1)}}</td>
                            <td class="border-right text-align-center col-lg-6">{{getCurrentCondition(currObj)}}</td>
                            <td class="text-align-center col-lg-3 cursor-pointer">
                              <span>
                              <a class="text-decoration-underline" @click="performUserClickAction($event, 'edit_current_recommended_action_rule', index, currObj)">Edit</a> | 
                              <a class="text-decoration-underline" @click="performUserClickAction($event, 'delete_current_recommended_action_rule', index, currObj)">Delete</a>
                            </span>
                            </td>         
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row vertical-align margin-bottom-2Perc">
                  <div class="row col-md-1 col-lg-1"></div>
                  <div class="row col-md-3 col-lg-3 create-lesson-input-text-style-sub-label text-align-left">
                    <b>{{ performingEditOperation ? 'Update Existing' : 'Create New'}}</b>
                  </div>
                  <div class="create-lesson-input-text-style col-md-3 col-lg-3 text-align-right padding-right-0Px">  
                  </div>
                  <div class="col-md-4 col-lg-4">
                    <div class="form-group">
                      <div class="col-sm-12">
                      </div>
                    </div>
                  </div>
                  <div class="row col-md-3 col-lg-3"></div>
                </div>

                <div class="row vertical-align text-align-left">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-2 col-md-2 col-lg-2 font-size-12px">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        If
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc font-size-12px">
                    <div class="form-group">
                      <div class="col-sm-12 font-size-12px">
                        # of Scheduled Meeting
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc font-size-12px">
                      return # of Recommended Actions to user
                  </div>
                  <div class="col-md-1 col-lg-1 text-align-left"></div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                </div>

                <div class="row margin-bottom-2Perc vertical-align">
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                  <div class="col-sm-2 col-md-2 col-lg-2">
                    <select class="form-control" v-model="conditionOperatorValue">
                      <option :value=constants.RecommendActionOperatorEnum.None disabled>Select</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.LessThan>&#60; (Less Than)</option> -->
                      <option :value=constants.RecommendActionOperatorEnum.LessThanEqual>&le; (Less Than Or Equal To)</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.GreaterThan>&gt; (Greater Than)</option> -->
                      <option :value=constants.RecommendActionOperatorEnum.GreaterThanEqual>&ge; (Greater Than Or Equal To)</option>
                      <!-- <option :value=constants.RecommendActionOperatorEnum.EqualTo>&#61; (Equal To)</option> -->
                    </select>
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-right-0Px">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        <input type="number" class="form-control" v-model="numberofMeetingsValue">
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-1 col-md-1 col-lg-1 font-size-12px">
                    then
                  </div>
                  <div class="col-sm-3 col-md-3 col-lg-3 padding-left-0Perc">
                    <div class="form-group">
                      <div class="col-sm-12 padding-left-0Perc Padding-right-0Px">
                        <input type="number" class="form-control" v-model="returnActionCountValue">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1 col-lg-1 text-align-left">
                    <span class="glyphicon glyphicon-plus cursor-pointer font-size-18px text-color-green" @click="performUserClickAction($event, 'add_recommended_actions_rule', -1, null)" v-if="!performingEditOperation"></span>
                    <span class="glyphicon glyphicon-ok cursor-pointer font-size-18px text-color-green" @click="performUserClickAction($event, 'update_previously_recommended_actions_rule', -1, null)" v-if="performingEditOperation"></span>            
                    <span class="glyphicon glyphicon-remove cursor-pointer font-size-18px text-color-red" @click="performUserClickAction($event, 'clear_previously_added_recommended_actions_rule', -1, null)" v-if="performingEditOperation"></span>            
                  </div>
                  <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1"></div>
                </div>
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>  
                <div class="col-md-2 col-lg-2">
                  <!-- ToDo: Track this -->
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateCohortDetails">Update Cohort</button>
                </div>  
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>         
          </div>
      </div>
    </div> 
</template>
<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { cohortService } from '@/server-util/cohort-service'
import { groupCourseService } from '@/server-util/group-course-service'
import AlertBox from '@/components/AlertOverlay'
import { find, findIndex } from 'lodash'
export default {
  props: ['cohortObj'],
  name: 'update-cohort',
  created () {
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      constants: constants,
      cohortObjectToPass: {
        CohortId: '',
        CohortName: '',
        StartTS: '',
        EndTS: '',
        GroupCourseMasterId: '',
        RecommendActionsData: []
      },
      recommendActionsDataObj: {
        NumberofMeetings: 0,
        ConditionOperator: -1,
        ReturnActionCount: 0
      },
      showAlertDialog: false,
      errorMsg: '',
      date1: new Date(),
      config1: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        defaultDate: null
      },
      date2: new Date(),
      config2: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        defaultDate: null
      },
      showRecommendedActionUI: false,
      performingEditOperation: false,
      currRecordIndexSelectedForEdit: -1
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker
  },
  methods: {
    foundSameRule: function () {
      const foundIndex = findIndex(this.cohortObjectToPass.RecommendActionsData, (currObj) => {
        return (currObj.NumberofMeetings === this.numberofMeetingsValue && currObj.ConditionOperator === this.conditionOperatorValue && currObj.ReturnActionCount === this.returnActionCountValue)
      })
      return foundIndex > -1
    },
    validateRequiredFieldBeforeAddIntoRecommendedActionList: function () {
      if (this.numberofMeetingsValue === undefined && this.numberofMeetingsValue === null && this.numberofMeetingsValue === 'null' && this.numberofMeetingsValue === '') {
        this.showAlertDialog = true
        this.errorMsg = '# of Scheduled Meeting can\'t be empty.'
        return false
      } else if (this.conditionOperatorValue === -1) {
        this.showAlertDialog = true
        this.errorMsg = 'Please specify condition for given rule.'
        return false
      } else if (this.returnActionCountValue === undefined && this.returnActionCountValue === null && this.returnActionCountValue === 'null' && this.returnActionCountValue === '') {
        this.showAlertDialog = true
        this.errorMsg = '# of Recommended Actions to return can\'t be empty.'
        return false
      } else if (this.cohortObjectToPass.RecommendActionsData.length > 0 && this.foundSameRule()) {
        this.showAlertDialog = true
        this.errorMsg = 'Given rule already exists in the list.'
        return false
      }
      return true
    },
    performUserClickAction: function (event, operationName, currRecordIndex, currObj) {
      switch (operationName) {
        default:
          break
        case 'update_previously_recommended_actions_rule':
          if (this.currRecordIndexSelectedForEdit > -1) {
            if (this.validateRequiredFieldBeforeAddIntoRecommendedActionList()) {
              var objToPush = {
                NumberofMeetings: this.numberofMeetingsValue,
                ConditionOperator: this.conditionOperatorValue,
                ReturnActionCount: this.returnActionCountValue
              }
              this.cohortObjectToPass.RecommendActionsData[this.currRecordIndexSelectedForEdit] = objToPush
              this.numberofMeetingsValue = 0
              this.conditionOperatorValue = -1
              this.returnActionCountValue = 0
              this.performingEditOperation = false
              this.currRecordIndexSelectedForEdit = -1
            }
          }
          break
        case 'clear_previously_added_recommended_actions_rule':
          this.numberofMeetingsValue = 0
          this.conditionOperatorValue = -1
          this.returnActionCountValue = 0
          this.performingEditOperation = false
          this.currRecordIndexSelectedForEdit = -1
          break
        case 'edit_current_recommended_action_rule':
          var objToEdit = {
            NumberofMeetings: currObj.NumberofMeetings,
            ConditionOperator: currObj.ConditionOperator,
            ReturnActionCount: currObj.ReturnActionCount
          }
          this.recommendActionsDataObjValue = objToEdit
          this.performingEditOperation = true
          this.currRecordIndexSelectedForEdit = currRecordIndex
          break
        case 'delete_current_recommended_action_rule':
          if (currRecordIndex > -1) {
            this.cohortObjectToPass.RecommendActionsData.splice(currRecordIndex, 1)
          }
          if (this.performingEditOperation) {
            this.numberofMeetingsValue = 0
            this.conditionOperatorValue = -1
            this.returnActionCountValue = 0
            this.performingEditOperation = false
            this.currRecordIndexSelectedForEdit = -1
          }
          break
        case 'add_recommended_actions_rule':
          if (this.validateRequiredFieldBeforeAddIntoRecommendedActionList()) {
            objToPush = {
              NumberofMeetings: this.numberofMeetingsValue,
              ConditionOperator: this.conditionOperatorValue,
              ReturnActionCount: this.returnActionCountValue
            }
            this.cohortObjectToPass.RecommendActionsData.push(objToPush)
            this.numberofMeetingsValue = 0
            this.conditionOperatorValue = -1
            this.returnActionCountValue = 0
            this.performingEditOperation = false
            this.currRecordIndexSelectedForEdit = -1
          }
          break
      }
    },
    getCurrentCondition: function (currObj) {
      var valueToReturn = ''
      valueToReturn = ''
      switch (currObj.ConditionOperator) {
        case constants.RecommendActionOperatorEnum.None:
        default:
          valueToReturn += ' Not Found '
          break
        case constants.RecommendActionOperatorEnum.LessThan:
          valueToReturn += ' Less than '
          break
        case constants.RecommendActionOperatorEnum.LessThanEqual:
          valueToReturn += ' Less than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.GreaterThan:
          valueToReturn += ' Greater than '
          break
        case constants.RecommendActionOperatorEnum.GreaterThanEqual:
          valueToReturn += ' Greater than or Equals to '
          break
        case constants.RecommendActionOperatorEnum.EqualTo:
          valueToReturn += ' Equals to '
          break
      }
      valueToReturn += currObj.NumberofMeetings + ' then return '
      valueToReturn += currObj.ReturnActionCount + ' action' + (currObj.ReturnActionCount > 1 ? 's' : '')
      return valueToReturn
    },
    updateShowEditCohortOverlayFlag: function (event, flagToUpdate) {
      this.$emit('updateEditDetailsOverlayFlag', flagToUpdate)
    },
    setDefaultValues: function () {
      this.cohortObjectToPass.CohortId = this.cohortObj.CohortId
      this.groupCourseMasterIdValue = this.cohortObj.GroupCourseMasterId
      this.cohortObjectToPass.RecommendActionsData = (this.cohortObj.RecommendActionsData !== undefined && this.cohortObj.RecommendActionsData !== 'undefined' && this.cohortObj.RecommendActionsData !== null && this.cohortObj.RecommendActionsData !== 'null' && this.cohortObj.RecommendActionsData !== '') ? JSON.parse(this.cohortObj.RecommendActionsData) : []
      var date1 = new Date(this.cohortObj.StartTS)
      this.config1.defaultDate = this.cohortObj.StartTS
      var splitedDateObj1 = date1.toLocaleDateString().split('/')
      this.date1 = splitedDateObj1[1] + '/' + splitedDateObj1[0] + '/' + splitedDateObj1[2] + ' ' + this.formatAMPM(date1)
      var date2 = new Date(this.cohortObj.EndTS)
      this.config2.defaultDate = this.cohortObj.EndTS
      var splitedDateObj2 = date2.toLocaleDateString().split('/')
      this.date2 = splitedDateObj2[1] + '/' + splitedDateObj2[0] + '/' + splitedDateObj2[2] + ' ' + this.formatAMPM(date2)
    },
    formatAMPM: function (date) {
      var hours = date.getHours()
      var minutes = date.getMinutes()
      var seconds = '00'
      var ampm = hours >= 12 ? 'PM' : 'AM'
      hours = hours % 12
      if (!hours) {
        hours = 12
      }
      // hours = hours ? hours : 12
      minutes = minutes < 10 ? '0' + minutes : minutes
      var strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm
      return strTime
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        } else {
          this.setDefaultValues()
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                _this.$store.state.isLoading = false
                this.setDefaultValues()
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    },
    updateCohortDetails: function (event) {
      var _this = this
      var storeObj = this.$store
      if (this.cohortObjectToPass.CohortName === '' || this.cohortObjectToPass.CohortName === undefined || this.cohortObjectToPass.CohortName.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Name can\'t be empty.'
        return
      }
      if (this.cohortObjectToPass.CohortName.trim().match(/[!@#$%^&*()_+\-=[\]{};':"\\|,<>/?]/)) {
        this.showAlertDialog = true
        this.errorMsg = 'Special character(s) are not allowed in the name.'
        return
      }
      if (!this.validateCohortName()) {
        this.showAlertDialog = true
        this.errorMsg = 'More than one white space in between the name is not allowed.'
        return
      }
      /*
      if (this.date1 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a start date.'
        return
      }
      if (this.date2 === null) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select an end date.'
        return
      }
      if (Date.parse(this.date1) > Date.parse(this.date2)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date must be less than the end date.'
        return
      }
      if (Date.parse(this.date1) === Date.parse(this.date2)) {
        this.showAlertDialog = true
        this.errorMsg = 'Start date and end date can\'t be same.'
        return
      }
      */
      // AK: assign values before update
      this.cohortObjectToPass.StartTS = this.date1
      this.cohortObjectToPass.EndTS = this.date2
      if (this.cohortObjectToPass.CohortName === this.cohortObj.CohortName && this.cohortObjectToPass.StartTS === this.cohortObj.StartTS && this.cohortObjectToPass.EndTS === this.cohortObj.EndTS) {
        this.$emit('updateEditDetailsOverlayFlag', false)
        return
      }
      if (this.cohortObjectToPass !== undefined || this.cohortObjectToPass.length > 0) {
        // AK: Start Showing Spinner (ManageGroup file)
        this.cohortObjectToPass.RecommendActionsData = (this.showRecommendedActionUI && this.cohortObjectToPass.RecommendActionsData !== undefined && this.cohortObjectToPass.RecommendActionsData !== 'undefined' && this.cohortObjectToPass.RecommendActionsData !== null && this.cohortObjectToPass.RecommendActionsData !== 'null' && this.cohortObjectToPass.RecommendActionsData !== '' && this.cohortObjectToPass.RecommendActionsData.length !== 0) ? JSON.stringify(this.cohortObjectToPass.RecommendActionsData) : null
        _this.$emit('showSpinner', true)
        cohortService
            .updateCohort(storeObj.state.access_token, _this.cohortObjectToPass)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Refresh Cohort List (ManageCohortsDetails file)
                _this.$emit('refreshCohortList', true)
                this.$emit('updateEditDetailsOverlayFlag', false)
                _this.$emit('showSpinner', false)
              } else {
                // AK: Hide Spinner
                _this.$emit('showSpinner', false)
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              _this.$emit('showSpinner', false)
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
              // this.errorMsg = 'Error updating cohort details. Please check the date format and try again.'
            })
      } else {
        console.log(
          'Selected cohortObjectToPass Object is NULL hence declined UPDATE Cohort OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      // AK : Do not hide the Update Group Overlay if Warning / Error is issued (Allow user to explicity close it)
      this.$emit('ShowUpdateLesson', true)
      this.showAlertDialog = value
    },
    validateCohortName: function () {
      if (/^(\w+\s?)*\s*$/.test(this.cohortObjectToPass.CohortName)) {
        return true
      }
      return false
    }
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    cohortNameValue: {
      get: function () {
        this.cohortObjectToPass.CohortName = this.cohortObj.CohortName
        return this.cohortObj.CohortName
      },
      set: function (newValue) {
        this.cohortObjectToPass.CohortName = newValue
      }
    },
    startTSValue: {
      get: function () {
        this.cohortObjectToPass.StartTS = this.cohortObj.StartTS
        return this.cohortObj.StartTS
      },
      set: function (newValue) {
        this.cohortObjectToPass.StartTS = newValue
      }
    },
    endTSValue: {
      get: function () {
        this.cohortObjectToPass.EndTS = this.cohortObj.EndTS
        return this.cohortObj.EndTS
      },
      set: function (newValue) {
        this.cohortObjectToPass.EndTS = newValue
      }
    },
    recommendActionsDataObjValue: {
      get: function () {
        return this.recommendActionsDataObj
      },
      set: function (newValue) {
        this.recommendActionsDataObj = newValue
      }
    },
    numberofMeetingsValue: {
      get: function () {
        return this.recommendActionsDataObjValue.NumberofMeetings
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = '# of Scheduled Meeting value must be positive value.'
          } else {
            this.recommendActionsDataObjValue.NumberofMeetings = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = '# of Scheduled Meeting value must be a non empty digit value.'
        }
      }
    },
    returnActionCountValue: {
      get: function () {
        return this.recommendActionsDataObjValue.ReturnActionCount
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = '# of Recommended Actions to return value must be positive value.'
          } else {
            this.recommendActionsDataObjValue.ReturnActionCount = parseInt(newValue)
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = '# of Recommended Actions to return value must be a non empty digit value.'
        }
      }
    },
    conditionOperatorValue: {
      get: function () {
        return this.recommendActionsDataObjValue.ConditionOperator
      },
      set: function (newValue) {
        this.recommendActionsDataObjValue.ConditionOperator = parseInt(newValue)
      }
    },
    groupCourseMasterIdValue: {
      get: function () {
        return this.cohortObjectToPass.GroupCourseMasterId
      },
      set: function (newValue) {
        this.cohortObjectToPass.GroupCourseMasterId = newValue
        const foundObj = find(this.getGroupCourseList, (currentObj) => {
          return newValue === currentObj.GroupCourseMasterId
        })
        if (foundObj !== undefined && foundObj !== 'undefined' && foundObj !== null && foundObj !== 'null' && foundObj !== '') {
          this.showRecommendedActionUI = (foundObj.CourseMasterId === constants.Default_Meeting_Mentor_Course)
        } else {
          this.showRecommendedActionUI = false
          this.cohortObjectToPass.RecommendActionsData = []
          this.returnActionCountValue = 0
          this.conditionOperatorValue = -1
          this.numberofMeetingsValue = 0
        }
      }
    }
  }
}
</script>

<style scoped>

.Padding-right-0Px {
  padding-right: 0px;
}
.padding-left-0Perc {
  padding-left: 0px;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-15px {
  font-size: 15px;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-decoration-underline {
  text-decoration: underline;
}

.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 7%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  /* font-size: 36px; */
  color: #818181;
  /* display: block; */
  transition: 0.3s;
}

.text-color-green {
  color: green;
  background: white;
  border-radius: 50%;
  border: 1px solid gainsboro;
  padding: 5px;
}

.text-color-red {
  color: red;
  background: white;
  border-radius: 50%;
  border: 1px solid gainsboro;
  padding: 5px;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 15px;
}

.create-lesson-input-text-style-sub-label {
  color: #f39c12;
  font-size: 13px;
  text-decoration: underline;
}

.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-3Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}
.padding-left-0Perc {
  padding-left: 0%;
}

.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateCohortDetailsOverlay.vue